// 登录等接口已对接后端
export const USE_MOCK = false;

function resolveWsUrl() {
    if (typeof window === 'undefined') {
        return 'ws://127.0.0.1:8585';
    }
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    if (process.env.NODE_ENV === 'development') {
        return `${protocol}//${window.location.hostname}:8585`;
    }
    // 线上走 443 + /ws，由 Nginx 反代到 8585
    return `${protocol}//${window.location.host}/ws`;
}

export const WS_URL = resolveWsUrl();
